import { resolveImage } from "@/lib/api";
import { BadgeCheck, Building2 } from "lucide-react";

export default function Colleges({ data }) {
  const items = data?.items || [];
  return (
    <section id="colleges" data-testid="section-colleges" className="section-pad bg-white">
      <div className="container-pad">
        <div className="max-w-2xl">
          <div className="kicker">{data.kicker || "Affiliations"}</div>
          <h2 className="heading-main mt-4">{data.title}</h2>
          <p className="heading-sub">PCI-approved partner colleges — direct admission guidance available.</p>
        </div>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((c, i) => (
            <CollegeCard key={i} college={c} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function CollegeCard({ college, index }) {
  const hasImage = !!(college.image && college.image.trim());

  if (hasImage) {
    return (
      <div
        className="card-elev overflow-hidden group flex flex-col"
        data-testid={`college-card-${index}`}
      >
        <div className="aspect-[5/3] overflow-hidden bg-slate-100">
          <img
            src={resolveImage(college.image)}
            alt={college.name}
            className="w-full h-full object-cover group-hover:scale-105 transition duration-700"
          />
        </div>
        <div className="p-5">
          <div className="flex items-center gap-1.5 text-xs font-semibold text-teal-700">
            <BadgeCheck className="w-3.5 h-3.5" /> Authorised
          </div>
          <h3 className="mt-2 font-bold text-[#0F172A] leading-snug">{college.name}</h3>
          <div className="mt-1 text-xs text-slate-500">{college.code}</div>
        </div>
      </div>
    );
  }

  // Text-only card — no image slot, richer typographic layout
  return (
    <div
      className="relative card-elev p-6 flex flex-col justify-between min-h-[220px] group bg-gradient-to-br from-white via-white to-[#F0FDFA] overflow-hidden"
      data-testid={`college-card-${index}`}
    >
      <div className="absolute -top-8 -right-8 w-32 h-32 rounded-full bg-teal-500/5 group-hover:bg-teal-500/10 transition" />
      <div className="relative">
        <div className="flex items-center justify-between gap-3">
          <div className="w-12 h-12 rounded-xl bg-[#1E3A8A] text-white grid place-items-center shadow-sm group-hover:bg-teal-600 transition">
            <Building2 className="w-5 h-5" />
          </div>
          <span className="inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-teal-700 bg-teal-50 border border-teal-100 rounded-full px-2.5 py-1">
            <BadgeCheck className="w-3 h-3" /> Authorised
          </span>
        </div>
        <h3 className="mt-5 font-bold text-lg text-[#0F172A] leading-snug">{college.name}</h3>
      </div>
      <div className="relative mt-5 pt-4 border-t border-slate-100">
        <div className="text-xs font-semibold text-slate-500 tracking-wider uppercase">
          {college.code || "Affiliation on request"}
        </div>
      </div>
    </div>
  );
}
